export const ASPECT_RATIOS = {
  "16:9": 16 / 9,
  "9:16": 9 / 16,
  "1:1": 1,
  "3:4": 3 / 4,
} as const;

export type ProjectAspectRatio = keyof typeof ASPECT_RATIOS;

export type ProjectMedia = ResponsiveMediaFields & {
  id: string;
  title: string;
  category: string;
  year: string;
  description: string;
  mediaType: "image" | "video";
  src: string;
  videoSrc?: string;
  mediaAssetId?: string;
  aspectRatio: ProjectAspectRatio;
  accent: string;
};

// Carousel records intentionally start without media. Upload final assets from
// the admin when the persistent media backend is available.
export const projects: ProjectMedia[] = [
  {
    id: "attendance-os",
    title: "Attendance OS",
    category: "Product system",
    year: "2026",
    description: "A fast, legible event and attendance workflow for teams on the move.",
    mediaType: "image",
    src: "",
    aspectRatio: "16:9",
    accent: "#b9ff66",
  },
  {
    id: "vanta-mobile",
    title: "Vanta Mobile",
    category: "UI / UX",
    year: "2026",
    description: "A focused mobile experience built around rhythm, hierarchy, and touch.",
    mediaType: "image",
    src: "",
    aspectRatio: "9:16",
    accent: "#ff795f",
  },
  {
    id: "nexus-identity",
    title: "Nexus Identity",
    category: "Brand design",
    year: "2025",
    description: "A modular identity language for an intelligent, connected product.",
    mediaType: "image",
    src: "",
    aspectRatio: "1:1",
    accent: "#9d81ff",
  },
  {
    id: "devcon-campaign",
    title: "Devcon Campaign",
    category: "Event graphics",
    year: "2025",
    description: "A kinetic campaign system designed to move across print and screens.",
    mediaType: "image",
    src: "",
    aspectRatio: "3:4",
    accent: "#55d9ff",
  },
  {
    id: "orbit-platform",
    title: "Orbit Platform",
    category: "Full-stack development",
    year: "2026",
    description: "A clear command surface for complex data, decisions, and collaboration.",
    mediaType: "image",
    src: "",
    aspectRatio: "16:9",
    accent: "#ffcf5c",
  },
  {
    id: "kinetic-frames",
    title: "Kinetic Frames",
    category: "Motion study",
    year: "2025",
    description: "A video-ready motion system exploring type, pace, and spatial transitions.",
    mediaType: "video",
    src: "",
    aspectRatio: "3:4",
    accent: "#ff6bb5",
  },
  {
    id: "mono-objects",
    title: "Mono Objects",
    category: "Visual identity",
    year: "2025",
    description: "A monochrome identity made tactile through form, light, and material.",
    mediaType: "image",
    src: "",
    aspectRatio: "1:1",
    accent: "#f3f0e8",
  },
  {
    id: "terra-prototype",
    title: "Terra Prototype",
    category: "Product innovation",
    year: "2026",
    description: "An experimental product concept connecting material choices and impact.",
    mediaType: "image",
    src: "",
    aspectRatio: "9:16",
    accent: "#62e49b",
  },
  {
    id: "synthesis-lab",
    title: "Synthesis Lab",
    category: "Creative coding",
    year: "2026",
    description: "A generative web experiment where systems turn into living compositions.",
    mediaType: "image",
    src: "",
    aspectRatio: "16:9",
    accent: "#7e8dff",
  },
  {
    id: "field-notes",
    title: "Field Notes",
    category: "Editorial system",
    year: "2025",
    description: "A flexible editorial language for stories, observations, and small details.",
    mediaType: "image",
    src: "",
    aspectRatio: "3:4",
    accent: "#f39b61",
  },
];
import type { ResponsiveMediaFields } from "../types/media";
